import axios from 'axios'

const addbotsToProfile = async (bot, profileHexId) => {
  const data = `/api/v1/profiles/${profileHexId}`
  await axios.post(`/api/v1/bots/${bot.hexId}/profiles`, data, {
    headers: {
      'Content-Type': 'text/uri-list'
    }
  })
}

const deleteBotFromProfile = async (bot, profile) => {
  await axios.delete(`/api/v1/bots/${bot.hexId}/profiles/${profile.hexId}`)
}

const fetchProfiledBots = async profile => {
  const { data } = await axios.get(`/api/v1/profiles/${profile.hexId}/bots`)
  return data._embedded.bots
}

const fetchProfiledWorkflows = async profile => {
  const { data } = await axios.get(
    `/api/v1/profiles/${profile.hexId}/workflows`
  )
  return data._embedded.workflows
}

const addWorkflowToProfile = async (workflow, profile) => {
  let data = `/api/v1/profiles/${profile.hexId}`
  await axios.post(`/api/v1/workflows/${workflow.hexId}/profiles`, data, {
    headers: {
      'Content-Type': 'text/uri-list'
    }
  })
}

const deleteWorkflowFromProfile = async (workflow, profile) => {
  await axios.delete(
    `/api/v1/workflows/${workflow.hexId}/profiles/${profile.hexId}`
  )
}

const fetchProfiledRules = async profile => {
  const { data } = await axios.get(`/api/v1/profiles/${profile.hexId}/rules`)
  return data._embedded.rules
}

const addRuleToProfile = async (rule, profile) => {
  let data = `/api/v1/profiles/${profile.hexId}`
  return await axios.post(`/api/v1/rules/${rule.hexId}/profiles`, data, {
    headers: {
      'Content-Type': 'text/uri-list'
    }
  })
}

const fetchProfiledSelfServices = async profile => {
  const { data } = await axios.get(
    `/api/v1/profiles/${profile.hexId}/selfServices`
  )
  return data._embedded.selfServices
}

const deleteRuleFromProfile = async (rule, profile) => {
  await axios.delete(`/api/v1/rules/${rule.hexId}/profiles/${profile.hexId}`)
}

const addSelfServiceToProfile = async (selfService, profile) => {
  let data = `/api/v1/profiles/${profile.hexId}`
  return await axios.post(
    `/api/v1/selfServices/${selfService.hexId}/profiles`,
    data,
    {
      headers: {
        'Content-Type': 'text/uri-list'
      }
    }
  )
}

const deleteSelfServiceFromProfile = async (selfService, profile) => {
  await axios.delete(
    `/api/v1/selfServices/${selfService.hexId}/profiles/${profile.hexId}`
  )
}

const fetchProfiledHoneyUsers = async profile => {
  const { data } = await axios.get(
    `/api/v1/profiles/${profile.hexId}/honeyUsers`
  )
  return data._embedded.honeyUsers
}

const addHoneyUserToProfile = async (honeyUser, profile) => {
  let data = `/api/v1/profiles/${profile.hexId}`
  return await axios.post(
    `/api/v1/honeyUsers/${honeyUser.hexId}/profiles`,
    data,
    {
      headers: {
        'Content-Type': 'text/uri-list'
      }
    }
  )
}

const deleteHoneyUserFromProfile = async (honeyUser, profile) => {
  await axios.delete(
    `/api/v1/honeyUsers/${honeyUser.hexId}/profiles/${profile.hexId}`
  )
}

const fetchProfiledHoneyForms = async profile => {
  const { data } = await axios.get(
    `/api/v1/profiles/${profile.hexId}/honeyForms`
  )
  return data._embedded.honeyForms
}

const addHoneyFormToProfile = async (form, profile) => {
  let data = `/api/v1/profiles/${profile.hexId}`
  await axios.post(`/api/v1/honeyForms/${form.hexId}/profiles`, data, {
    headers: {
      'Content-Type': 'text/uri-list'
    }
  })
}

const deleteHoneyFormFromProfile = async (form, profile) => {
  axios.delete(`/api/v1/honeyForms/${form.hexId}/profiles/${profile.hexId}`)
}

export default {
  addbotsToProfile,
  fetchProfiledBots,
  deleteBotFromProfile,
  fetchProfiledWorkflows,
  addWorkflowToProfile,
  deleteWorkflowFromProfile,
  addRuleToProfile,
  fetchProfiledRules,
  deleteRuleFromProfile,
  fetchProfiledSelfServices,
  addSelfServiceToProfile,
  deleteSelfServiceFromProfile,
  addHoneyUserToProfile,
  fetchProfiledHoneyUsers,
  deleteHoneyUserFromProfile,
  fetchProfiledHoneyForms,
  addHoneyFormToProfile,
  deleteHoneyFormFromProfile
}
